<template>
    <div class="table-grid" :style="{'--columns': (columns || []).map(({width}) => width).join(' ')}">
        <div v-for="col in columns" :key="col.key" class="header">
            {{ col.label }}
        </div>
        <div v-for="(row, index) in rows" :key="row.key" class="row">
            <slot v-if="$scopedSlots.columns" name="columns" :row="row" :index="index"></slot>
            <div v-else v-for="col in columns" :key="col.key">
                {{ row[col.key] ? row[col.key] : '--' }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TableGrid',
    props: {
        "columns": Array,
        "rows": Array
    },
    data() {
        return {
            // Component data
        };
    },
    methods: {
        // Component methods
    },
    mounted() {
        // Lifecycle hook
    }
};
</script>

<style scoped>
.table-grid {
    display: grid;
    grid-template-columns: var(--columns, repeat(auto-fill, minmax(50px, 1fr)));
}
.table-grid div {
    border-bottom: 1px solid #ebebeb;
    padding: 0.5rem;
}
.header {
    font-weight: bold;
    background: #ebebeb;
}
.row {
    display: contents;
}
</style>